// extracted by mini-css-extract-plugin
export default {"adHostResultTableContainer":"AdminAdHostResultPage_adHostResultTableContainer__VBo9B"};